module.exports = __webpack_public_path__ + "img/myeasycharge-logo@2x.39367335.png";